import {
    cityToCitySelectors as c2cSelectors,
    scheduleActions,
} from 'wanderu-ducks-seo';
import Logger from 'wanderu-logger';

import { getScheduleData } from '../../services/seoService';
import {
    actions,
    reducer,
    selectors,
    namespace,
} from './base';

const logger = Logger.getLogger('fetchSchedule');

function fetchSchedule(localeAwareScheduleId, mode) {
    return async (dispatch, getState) => {
        let error = null;
        const locationData = c2cSelectors.selectLocationData(getState(), localeAwareScheduleId);
        dispatch(actions.startWork(localeAwareScheduleId));
        try {
            const { result } = await getScheduleData({
                departCity: locationData.departure.wcityid,
                arriveCity: locationData.arrival.wcityid,
                transMode: mode,
            });
            dispatch(scheduleActions.setSchedule(localeAwareScheduleId, result));
        } catch (ex) {
            logger.error('fetch', ex, {
                localeAwareScheduleId,
            });

            error = {
                code: ex.code,
                message: 'set schedule failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareScheduleId, undefined, error));
        }
    };
}

const fetchScheduleSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_CITY_TO_CITY';
    },
};

const fetchScheduleAction = {
    fetchSchedule,
    ...fetchScheduleSelectors,
};

export {
    fetchScheduleAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
